export default "__VITE_ASSET__C76rZD_l__"